<!-- src/views/book/KpsMapView.vue (read-only с навигацией) -->
<template>
  <section class="page">
    <h2 class="page__title">{{ $t('kps.mapView.title') }}</h2>
    <p class="section-subtitle">{{ $t('kps.mapView.subtitle') }}</p>

    <div ref="mapArea" class="map-area" :class="{ 'map-area--fullscreen': isFullscreen }">
      <button
        class="map-fullscreen-btn"
        :title="isFullscreen ? $t('kps.mapView.collapse') : $t('kps.mapView.fullscreen')"
        @click="toggleFullscreen"
      >
        <svg v-if="!isFullscreen" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 7V3h4M21 7V3h-4M3 17v4h4M21 17v4h-4"/>
        </svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M8 3v4H4M16 3v4h4M8 21v-4H4M16 21v-4h4"/>
        </svg>
      </button>

      <ChpoMap
        ref="chpoMap"
        :selected-icon="null"
        :read-only="true"
      />
    </div>

    <div class="page__footer">
      <ViewNavButtons
        :prev-text="$t('common.back')"
        :next-text="$t('common.next')"
        :prev-to="{ path: '/kps/orders' }"
        :next-to="{ path: '/kps/personnel' }"
      />
    </div>
  </section>
</template>

<script>
import ViewNavButtons from '@/components/navigation/ViewNavButtons.vue'
import ChpoMap from '@/components/maps/ChpoMap.vue'

export default {
  name: 'KpsMapView',
  components: { ViewNavButtons, ChpoMap },
  data() {
    return { isFullscreen: false }
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
    // Даём карте пересчитать размер под новую высоту контейнера
    setTimeout(() => this.refreshMapSize(), 200)
  },
  beforeUnmount() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
  },
  methods: {
    async toggleFullscreen() {
      const el = this.$refs.mapArea
      if (!el) return
      // Сразу включаем CSS-класс — он растягивает контейнер,
      // даже если браузер не поддерживает Fullscreen API.
      this.isFullscreen = !this.isFullscreen
      try {
        if (this.isFullscreen && !document.fullscreenElement) {
          await el.requestFullscreen()
        } else if (!this.isFullscreen && document.fullscreenElement) {
          await document.exitFullscreen()
        }
      } catch (e) {
        // если API не сработал — CSS-класс уже на месте, продолжаем
      }
      this.refreshMapSize()
    },
    onFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement || this.isFullscreen
      // если вышли через ESC — синхронизируем флаг
      if (!document.fullscreenElement) this.isFullscreen = false
      this.refreshMapSize()
    },
    refreshMapSize() {
      // даём DOM пересчитать размеры, потом пересоберём карту с zoom-to-fit
      setTimeout(() => {
        const map = this.$refs.chpoMap
        if (!map) return
        if (typeof map.fitToImage === 'function') {
          map.fitToImage()
        } else if (typeof map.invalidateSize === 'function') {
          map.invalidateSize()
        } else {
          window.dispatchEvent(new Event('resize'))
        }
      }, 150)
    },
  },
}
</script>

<style scoped>
.page {
  padding: 2rem;
  background: #f3f3f5;
  min-height: 100vh;
}

.page__title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #000;
}

.section-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 1.5rem;
}

.map-area {
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: calc(100vh - 360px);
  min-height: 520px;
  max-height: 900px;
  margin-bottom: 1.5rem;
}

/* native fullscreen — браузер сам делает элемент 100vw×100vh */
.map-area:fullscreen {
  width: 100%;
  height: 100%;
  border-radius: 0;
  margin: 0;
}

/* CSS-fallback (если Fullscreen API не сработал) */
.map-area--fullscreen {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  margin: 0;
  z-index: 9999;
}

/* растягиваем дочерний компонент карты в обоих режимах */
.map-area:fullscreen :deep(.map-shell),
.map-area--fullscreen :deep(.map-shell) {
  width: 100%;
  height: 100%;
}
.map-area:fullscreen :deep(.map),
.map-area--fullscreen :deep(.map) {
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 0;
}

.map-fullscreen-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 500;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  transition: background 0.15s;
}
.map-fullscreen-btn:hover { background: #fff; }

.page__footer {
  display: flex;
  justify-content: space-between;
}
</style>
